'use client';

import { useResponsiveQuery } from 'atomic-layout';
import React, { useCallback, useEffect, useState } from 'react';

import QRCode from '@/components/v3/QRCode';
import LINKS from '@/constants/links';
import { GAsendEvent } from '@/utils/Analytics';
import { handleAppsflyerUtmUrl } from '@/utils/handleAppsflyerUtmUrl';
import Button, { ButtonProps } from '@/app/components/base/ui/Button';

type TLinkOpenYourAccount = {
  className?: string;
  color?: ButtonProps['color'];
  size?: ButtonProps['size'];
  qrCodeLink?: string;
  ctaConfig?: {
    categories: string;
    action: string;
    label: string;
  };
  children?: React.ReactNode;
  onClick?: () => void;
  sectionReference?: string;
};

const ButtonOpenYourAccount: React.FC<TLinkOpenYourAccount> = ({
  qrCodeLink = LINKS.APP_LINK_QR_CODE,
  className,
  color,
  size,
  ctaConfig,
  children,
  onClick,
  sectionReference,
}) => {
  const isMobile = useResponsiveQuery({ to: 'lg' });
  const [utmUrl, setUtmUrl] = useState(qrCodeLink);
  const [toggleDrawer, setToggleDrawer] = useState(false);

  const updateUtmUrl = useCallback(
    () => setUtmUrl(handleAppsflyerUtmUrl(qrCodeLink)),
    [qrCodeLink],
  );

  useEffect(updateUtmUrl);

  const handleClickButton = () => {
    /* TODO: Não usamos mais CTAs config para o GA, devemos remover essas funções do código */
    ctaConfig &&
      GAsendEvent(ctaConfig.categories, ctaConfig.action, ctaConfig.label);

    !isMobile && setToggleDrawer(!toggleDrawer);
  };

  return (
    /* TODO: todas as const qrCodeLink são ajuste para atender a pagina de planos, devemos rever essa const */
    <>
      <QRCode
        qrCodeLink={qrCodeLink}
        isShowing={toggleDrawer}
        onToggle={() => setToggleDrawer(!toggleDrawer)}
      />
      {isMobile ? (
        <Button
          linkHref={utmUrl}
          size={size}
          color={color}
          sectionReference={sectionReference || 'Plans Cards'}
          onClick={() => {
            handleClickButton();
            onClick && onClick();
          }}
          className={`btn w-full min-w-full md:min-w-min ${className}`}
        >
          {children}
        </Button>
      ) : (
        <Button
          color={color}
          size={size}
          onClick={() => {
            handleClickButton();
            onClick && onClick();
          }}
          className={className}
          sectionReference={sectionReference || 'Plans Cards'}
        >
          {children}
        </Button>
      )}
    </>
  );
};

export default ButtonOpenYourAccount;
